"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_CommandingPresence_OnHealthChangeEventHandlerScript = void 0;
const __1 = require("../..");
const Duration_1 = require("../../core/Duration");
const EffectType_1 = require("../../core/effects/EffectType");
const EventType_1 = require("../../core/events/EventType");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
let Effect_CommandingPresence_OnHealthChangeEventHandlerScript = class Effect_CommandingPresence_OnHealthChangeEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.args.__type !== EventType_1.EventType.AttributeChanged) {
            return;
        }
        else if (event.args.attribute !== __1.AttributeType.Health) {
            return;
        }
        const expectedState = event.args.value > container.getPercentOfMaxHealth(handler.subject, 50) ? "applied"
            : "removed";
        // state is applied by default
        const actualState = handler.meta.state || "applied";
        if (actualState === expectedState) {
            return;
        }
        sequence = sequence.pushSequence("parallel");
        handler.meta.state = expectedState;
        switch (expectedState) {
            case "applied": {
                for (const ally of container.selectTargets(handler.subject, Target_1.Target.AllAllies)) {
                    container.applyBuff({
                        sequence,
                        creatorId: event.subject,
                        targetId: ally,
                        effect: new __1.CommandingPresenceEffectArgs(),
                        duration: Duration_1.Duration.Permanent
                    });
                }
                break;
            }
            case "removed": {
                for (const ally of container.selectTargets(handler.subject, Target_1.Target.AllAllies)) {
                    for (const effectId of container.getEffectsOfType(ally, EffectType_1.EffectType.CommandingPresence)) {
                        const effect = container.getEffect(effectId);
                        if (effect.creatorId !== handler.subject) {
                            continue;
                        }
                        container.cancelEffect(sequence, effectId);
                    }
                }
                break;
            }
        }
    }
};
Effect_CommandingPresence_OnHealthChangeEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_CommandingPresence_OnHealthChange")
], Effect_CommandingPresence_OnHealthChangeEventHandlerScript);
exports.Effect_CommandingPresence_OnHealthChangeEventHandlerScript = Effect_CommandingPresence_OnHealthChangeEventHandlerScript;
